import { supabase } from './supabase'

/**
 * Get all care plan templates for organization
 */
export const getCarePlanTemplates = async (organizationId, includePublic = true) => {
  try {
    let query = supabase
      .from('care_plan_templates')
      .select('*')
      .or(`organization_id.eq.${organizationId},is_public.eq.true`)
      .order('is_default', { ascending: false })
      .order('created_at', { ascending: false })

    const { data, error } = await query

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching templates:', error)
    throw error
  }
}

/**
 * Get template by ID
 */
export const getCarePlanTemplate = async (templateId) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_templates')
      .select('*')
      .eq('id', templateId)
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error fetching template:', error)
    throw error
  }
}

/**
 * Create care plan template
 */
export const createCarePlanTemplate = async (organizationId, templateData) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    const { data, error } = await supabase
      .from('care_plan_templates')
      .insert({
        organization_id: organizationId,
        name: templateData.name,
        description: templateData.description || null,
        category: templateData.category || 'general',
        template_data: templateData.templateData,
        is_public: templateData.isPublic || false,
        is_default: templateData.isDefault || false,
        created_by: user?.id,
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error creating template:', error)
    throw error
  }
}

/**
 * Update care plan template
 */
export const updateCarePlanTemplate = async (templateId, updates) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_templates')
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('id', templateId)
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error updating template:', error)
    throw error
  }
}

/**
 * Delete care plan template
 */
export const deleteCarePlanTemplate = async (templateId) => {
  try {
    const { error } = await supabase
      .from('care_plan_templates')
      .delete()
      .eq('id', templateId)

    if (error) throw error
    return true
  } catch (error) {
    console.error('Error deleting template:', error)
    throw error
  }
}

